import '../Styles/about.css'
function About() {
  return (
    <section>
        <p style={{padding: "10% 10%"}}>About page</p>
    </section>
  );
}

export default About;
